import { lazy } from 'react';

export const GroupListPage = lazy(() => import('./controller.js'));
